import { useState, useEffect } from 'react';
import WorkoutInputs from './components/WorkoutInputs';
import ResultsPanel from './components/ResultsPanel';
import { WorkoutInputs as WorkoutInputsType } from './types';
import { calculateFueling } from './utils/calcEngine';

export default function CalculatorPage() {
  const [inputs, setInputs] = useState<WorkoutInputsType>({
    sport: 'running',
    isRaceDay: false,
    durationHours: 2,
    durationMinutes: 0,
    swimMinutes: 45,
    bikeHours: 5,
    bikeMinutes: 30,
    runHours: 3,
    runMinutes: 45,
    intensity: 'moderate',
    carbTolerance: 'intermediate',
    heat: 'moderate',
    highSweatRate: false,
    caffeinePreference: 'moderate',
    bottles: []
  });

  const recommendation = calculateFueling(inputs);

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="text-2xl font-black text-white tracking-tighter">
            THRESH
          </a>
          <div className="flex items-center gap-8">
            <a href="/" className="text-white/80 hover:text-white font-medium transition-colors text-sm">
              Home
            </a>
            <a href="/calculator" className="text-[#00FF88] font-bold text-sm">
              Fueling Calculator
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="pt-24 pb-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-black text-white mb-4 tracking-tight">
              FUELING CALCULATOR
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Get personalized THRESH dosing recommendations based on your workout duration, intensity, and conditions.
            </p>
          </div>

          {/* Calculator Grid */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Left Panel - Inputs */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 h-fit">
              <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-wider">
                Your Workout
              </h2>
              <WorkoutInputs inputs={inputs} onChange={setInputs} />
            </div>

            {/* Right Panel - Results */}
            <div className="lg:sticky lg:top-24 h-fit">
              <ResultsPanel recommendation={recommendation} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}